// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Action$ReactHooksTemplate = require("./Action.res.js");
var Welcome$ReactHooksTemplate = require("./Welcome.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var LogicCondition$ReactHooksTemplate = require("./LogicCondition.res.js");

function id(t) {
  return t.id;
}

function trigger(t) {
  return t.trigger;
}

function category(t) {
  return t.category;
}

function priority(t) {
  return t.priority;
}

function conditions(t) {
  return t.conditions;
}

function deletedConditions(t) {
  return t.deletedConditions;
}

function actions(t) {
  return t.actions;
}

function setTrigger(t, trigger) {
  return {
          id: t.id,
          trigger: trigger,
          category: t.category,
          priority: t.priority,
          conditions: t.conditions,
          deletedConditions: t.deletedConditions,
          actions: t.actions,
          deletedActions: t.deletedActions
        };
}

function setConditions(conditions, t) {
  return {
          id: t.id,
          trigger: t.trigger,
          category: t.category,
          priority: t.priority,
          conditions: conditions,
          deletedConditions: t.deletedConditions,
          actions: t.actions,
          deletedActions: t.deletedActions
        };
}

function setDeletedConditions(t, deletedConditions) {
  return {
          id: t.id,
          trigger: t.trigger,
          category: t.category,
          priority: t.priority,
          conditions: t.conditions,
          deletedConditions: deletedConditions,
          actions: t.actions,
          deletedActions: t.deletedActions
        };
}

function setActions(actions, t) {
  return {
          id: t.id,
          trigger: t.trigger,
          category: t.category,
          priority: t.priority,
          conditions: t.conditions,
          deletedConditions: t.deletedConditions,
          actions: actions,
          deletedActions: t.deletedActions
        };
}

function setPriority(t, priority) {
  return {
          id: t.id,
          trigger: t.trigger,
          category: t.category,
          priority: priority,
          conditions: t.conditions,
          deletedConditions: t.deletedConditions,
          actions: t.actions,
          deletedActions: t.deletedActions
        };
}

function deletedActions(t) {
  return t.deletedActions;
}

function setDeletedActions(t, deletedActions) {
  return {
          id: t.id,
          trigger: t.trigger,
          category: t.category,
          priority: t.priority,
          conditions: t.conditions,
          deletedConditions: t.deletedConditions,
          actions: t.actions,
          deletedActions: deletedActions
        };
}

function make(trigger, category, conditions, priority, actions) {
  return {
          id: undefined,
          trigger: trigger,
          category: category,
          priority: priority,
          conditions: conditions,
          deletedConditions: /* [] */0,
          actions: actions,
          deletedActions: /* [] */0
        };
}

function decodeTrigger(json, questions, welcome, surveyId) {
  var triggerType = Json_decode.field("trigger_type", Json_decode.string, json);
  var triggerId = Json_decode.field("trigger_id", Json_decode.$$int, json);
  switch (triggerType) {
    case "Question" :
        return {
                TAG: "Question",
                _0: List.find((function (n) {
                        return Belt_Option.getExn(Question$ReactHooksTemplate.id(n)) === triggerId;
                      }), questions)
              };
    case "Survey" :
        return {
                TAG: "Survey",
                _0: surveyId
              };
    case "Welcome" :
        return {
                TAG: "Welcome",
                _0: Belt_Option.getExn(welcome)
              };
    default:
      return Js_exn.raiseError("Unknown trigger type");
  }
}

function decodeCategory(json) {
  var match = Json_decode.field("category", (function (param) {
          return Json_decode.optional(Json_decode.string, param);
        }), json);
  if (match === undefined) {
    return "Survey";
  }
  switch (match) {
    case "redirection" :
        return "Redirection";
    case "ticket_generation" :
        return "TicketGeneration";
    default:
      return "Survey";
  }
}

function decode(questions, welcome, thankYouList, dataFields, surveyId, redirectionUrls, ticketCategories, json) {
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          trigger: decodeTrigger(json, questions, welcome, surveyId),
          category: decodeCategory(json),
          priority: Json_decode.field("priority", Json_decode.$$int, json),
          conditions: Json_decode.field("conditions", (function (param) {
                  return Json_decode.list((function (json) {
                                return LogicCondition$ReactHooksTemplate.decode(json, questions, dataFields);
                              }), param);
                }), json),
          deletedConditions: /* [] */0,
          actions: Json_decode.field("actions", (function (param) {
                  return Json_decode.list((function (json) {
                                return Action$ReactHooksTemplate.decode(json, questions, thankYouList, redirectionUrls, ticketCategories);
                              }), param);
                }), json),
          deletedActions: /* [] */0
        };
}

function availableOptionsForLhs(t, questions, dataFields) {
  var xs = t.trigger;
  switch (xs.TAG) {
    case "Welcome" :
        return /* [] */0;
    case "Question" :
        var xs$1 = xs._0;
        return List.flatten(List.mapi((function (index, x) {
                          if (!Caml_obj.equal(Question$ReactHooksTemplate.uuid(xs$1), Question$ReactHooksTemplate.uuid(x))) {
                            return /* [] */0;
                          }
                          var match = Belt_Option.getExn(Belt_List.splitAt(questions, index + 1 | 0));
                          return Belt_List.concat(Belt_List.map(match[0], (function (q) {
                                            return {
                                                    TAG: "Question",
                                                    _0: q
                                                  };
                                          })), Belt_List.map(dataFields, (function (q) {
                                            return {
                                                    TAG: "DataField",
                                                    _0: q
                                                  };
                                          })));
                        }), questions));
    case "Survey" :
        return Belt_List.concat(Belt_List.map(questions, (function (q) {
                          return {
                                  TAG: "Question",
                                  _0: q
                                };
                        })), Belt_List.map(dataFields, (function (q) {
                          return {
                                  TAG: "DataField",
                                  _0: q
                                };
                        })));
    
  }
}

function encodeCategory(category) {
  switch (category) {
    case "Survey" :
        return "survey";
    case "Redirection" :
        return "redirection";
    case "TicketGeneration" :
        return "ticket_generation";
    
  }
}

function toJson(destroyOpt, t) {
  var destroy = destroyOpt !== undefined ? destroyOpt : false;
  var match = t.trigger;
  var triggerType;
  switch (match.TAG) {
    case "Welcome" :
        triggerType = "Welcome";
        break;
    case "Question" :
        triggerType = "Question";
        break;
    case "Survey" :
        triggerType = "Survey";
        break;
    
  }
  var x = t.trigger;
  var triggerId;
  switch (x.TAG) {
    case "Welcome" :
        triggerId = Welcome$ReactHooksTemplate.id(x._0);
        break;
    case "Question" :
        triggerId = Question$ReactHooksTemplate.id(x._0);
        break;
    case "Survey" :
        triggerId = x._0;
        break;
    
  }
  var action = Belt_List.head(Belt_List.keep(t.actions, (function (x) {
              var match = x.actionType;
              if (match.TAG === "Jump") {
                return true;
              } else {
                return false;
              }
            })));
  var encodedJumpAction;
  if (action !== undefined) {
    encodedJumpAction = Action$ReactHooksTemplate.jumpActionToJson(false, action);
  } else {
    var actionToDelete = Belt_List.head(Belt_List.keep(t.deletedActions, (function (x) {
                var match = x.actionType;
                if (match.TAG === "Jump") {
                  return true;
                } else {
                  return false;
                }
              })));
    encodedJumpAction = actionToDelete !== undefined ? Action$ReactHooksTemplate.jumpActionToJson(true, actionToDelete) : null;
  }
  var encodedSkipActions = Belt_List.toArray(Belt_List.concat(Belt_List.map(Belt_List.keep(t.deletedActions, (function (x) {
                      var match = x.actionType;
                      if (match.TAG === "Skip") {
                        return true;
                      } else {
                        return false;
                      }
                    })), (function (x) {
                  return Action$ReactHooksTemplate.skipActionToJson(true, x);
                })), Belt_List.map(Belt_List.keep(t.actions, (function (x) {
                      var match = x.actionType;
                      if (match.TAG === "Skip") {
                        return true;
                      } else {
                        return false;
                      }
                    })), (function (x) {
                  return Action$ReactHooksTemplate.skipActionToJson(undefined, x);
                }))));
  var action$1 = Belt_List.head(Belt_List.keep(t.actions, (function (x) {
              var match = x.actionType;
              if (match.TAG === "Redirection") {
                return true;
              } else {
                return false;
              }
            })));
  var encodedRedirectionActions;
  if (action$1 !== undefined) {
    encodedRedirectionActions = Action$ReactHooksTemplate.redirectionActionToJson(false, action$1);
  } else {
    var actionToDelete$1 = Belt_List.head(Belt_List.keep(t.deletedActions, (function (x) {
                var match = x.actionType;
                if (match.TAG === "Redirection") {
                  return true;
                } else {
                  return false;
                }
              })));
    encodedRedirectionActions = actionToDelete$1 !== undefined ? Action$ReactHooksTemplate.redirectionActionToJson(true, actionToDelete$1) : null;
  }
  var action$2 = Belt_List.head(Belt_List.keep(t.actions, (function (x) {
              var match = x.actionType;
              if (match.TAG === "TicketGeneration") {
                return true;
              } else {
                return false;
              }
            })));
  var encodedTicketGenerationActions;
  if (action$2 !== undefined) {
    encodedTicketGenerationActions = Action$ReactHooksTemplate.ticketGenerationActionToJson(false, action$2);
  } else {
    var actionToDelete$2 = Belt_List.head(Belt_List.keep(t.deletedActions, (function (x) {
                var match = x.actionType;
                if (match.TAG === "TicketGeneration") {
                  return true;
                } else {
                  return false;
                }
              })));
    encodedTicketGenerationActions = actionToDelete$2 !== undefined ? Action$ReactHooksTemplate.ticketGenerationActionToJson(true, actionToDelete$2) : null;
  }
  var encodedConditions = Belt_List.toArray(Belt_List.concat(Belt_List.map(t.conditions, (function (x) {
                  return LogicCondition$ReactHooksTemplate.toJson(undefined, x);
                })), Belt_List.map(t.deletedConditions, (function (x) {
                  return LogicCondition$ReactHooksTemplate.toJson(true, x);
                }))));
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "priority",
                  t.priority
                ],
                tl: {
                  hd: [
                    "trigger_type",
                    triggerType
                  ],
                  tl: {
                    hd: [
                      "trigger_id",
                      Json_encode.nullable((function (prim) {
                              return prim;
                            }), triggerId)
                    ],
                    tl: {
                      hd: [
                        "jump_action_attributes",
                        encodedJumpAction
                      ],
                      tl: {
                        hd: [
                          "skip_actions_attributes",
                          encodedSkipActions
                        ],
                        tl: {
                          hd: [
                            "redirection_action_attributes",
                            encodedRedirectionActions
                          ],
                          tl: {
                            hd: [
                              "ticket_generation_action_attributes",
                              encodedTicketGenerationActions
                            ],
                            tl: {
                              hd: [
                                "conditions_attributes",
                                encodedConditions
                              ],
                              tl: {
                                hd: [
                                  "_destroy",
                                  destroy
                                ],
                                tl: {
                                  hd: [
                                    "category",
                                    encodeCategory(t.category)
                                  ],
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

function availableTargetQuestions(t, questions) {
  var xs = t.trigger;
  switch (xs.TAG) {
    case "Question" :
        var xs$1 = xs._0;
        return List.flatten(List.mapi((function (index, x) {
                          if (Caml_obj.equal(xs$1, x)) {
                            return Belt_Option.getExn(Belt_List.splitAt(questions, index + 1 | 0))[1];
                          } else {
                            return /* [] */0;
                          }
                        }), questions));
    case "Welcome" :
    case "Survey" :
        return /* [] */0;
    
  }
}

function isQuestionInTrigger(t, question) {
  var x = t.trigger;
  switch (x.TAG) {
    case "Question" :
        return RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(x._0)) === RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(question));
    case "Welcome" :
    case "Survey" :
        return false;
    
  }
}

function isQuestionInCondition(t, question) {
  return List.mem(true, Belt_List.map(t.conditions, (function (x) {
                    var x$1 = x.conditionType;
                    switch (x$1.TAG) {
                      case "NumberCondition" :
                          var lhs = x$1._0.lhs;
                          if (lhs.TAG === "Question") {
                            return RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(lhs._0)) === RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(question));
                          } else {
                            return false;
                          }
                      case "StringCondition" :
                          var lhs$1 = x$1._0.lhs;
                          if (lhs$1.TAG === "Question") {
                            return RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(lhs$1._0)) === RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(question));
                          } else {
                            return false;
                          }
                      case "ListCondition" :
                          var lhs$2 = x$1._0.lhs;
                          if (lhs$2.TAG === "Question") {
                            return RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(lhs$2._0)) === RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(question));
                          } else {
                            return false;
                          }
                      case "DateCondition" :
                          var lhs$3 = x$1._0.lhs;
                          if (lhs$3.TAG === "Question") {
                            return RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(lhs$3._0)) === RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(question));
                          } else {
                            return false;
                          }
                      
                    }
                  })));
}

function questionInLogic(t, question) {
  return Belt_List.keep(t, (function (x) {
                if (isQuestionInTrigger(x, question) || isQuestionInCondition(x, question)) {
                  return true;
                } else {
                  return List.mem(true, Belt_List.flatten(Belt_List.map(x.actions, (function (x) {
                                        var x$1 = x.actionType;
                                        switch (x$1.TAG) {
                                          case "Skip" :
                                              var x$2 = x$1._0;
                                              if (x$2.TAG === "Questions") {
                                                return Belt_List.map(x$2._0, (function (x) {
                                                              return RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(x)) === RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(question));
                                                            }));
                                              } else {
                                                return /* [] */0;
                                              }
                                          case "Jump" :
                                              var x$3 = x$1._0;
                                              if (x$3.TAG === "Question") {
                                                return {
                                                        hd: RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(x$3._0)) === RandomId$ReactHooksTemplate.toString(Question$ReactHooksTemplate.uuid(question)),
                                                        tl: /* [] */0
                                                      };
                                              } else {
                                                return /* [] */0;
                                              }
                                          case "Redirection" :
                                          case "TicketGeneration" :
                                              return /* [] */0;
                                          
                                        }
                                      }))));
                }
              }));
}

function findLogicByTrigger(t, question) {
  return Belt_List.keep(t, (function (x) {
                return isQuestionInTrigger(x, question);
              }));
}

function getThankYouAssociatedLogic(thankYou, logicList) {
  return Belt_List.keep(logicList, (function (logic) {
                return Belt_List.some(logic.actions, (function (action) {
                              var match = action.actionType;
                              switch (match.TAG) {
                                case "Skip" :
                                    var thankYouList = match._0;
                                    if (thankYouList.TAG === "Questions") {
                                      return false;
                                    } else {
                                      return Belt_List.some(thankYouList._0, (function (t) {
                                                    return Caml_obj.equal(t, thankYou);
                                                  }));
                                    }
                                case "Jump" :
                                    var targetThankYou = match._0;
                                    if (targetThankYou.TAG === "Question") {
                                      return false;
                                    } else {
                                      return Caml_obj.equal(targetThankYou._0, thankYou);
                                    }
                                case "Redirection" :
                                case "TicketGeneration" :
                                    return false;
                                
                              }
                            }));
              }));
}

exports.id = id;
exports.trigger = trigger;
exports.category = category;
exports.priority = priority;
exports.conditions = conditions;
exports.deletedConditions = deletedConditions;
exports.actions = actions;
exports.deletedActions = deletedActions;
exports.setDeletedActions = setDeletedActions;
exports.setTrigger = setTrigger;
exports.setConditions = setConditions;
exports.setDeletedConditions = setDeletedConditions;
exports.setActions = setActions;
exports.setPriority = setPriority;
exports.make = make;
exports.decode = decode;
exports.availableOptionsForLhs = availableOptionsForLhs;
exports.availableTargetQuestions = availableTargetQuestions;
exports.toJson = toJson;
exports.questionInLogic = questionInLogic;
exports.getThankYouAssociatedLogic = getThankYouAssociatedLogic;
exports.findLogicByTrigger = findLogicByTrigger;
/* Action-ReactHooksTemplate Not a pure module */
